import { render, staticRenderFns } from "./ModalVideoSupport.vue?vue&type=template&id=22d737d1"
import script from "./ModalVideoSupport.vue?vue&type=script&lang=js"
export * from "./ModalVideoSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports